import {
  ContentMetricType,
  KeywordSection,
  ProductKeywordsPayload
} from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/api/apiTypes';

export type MetricFormatterVariant = 'utilization' | 'keywordUsage' | 'productivity' | 'popularity';

export const formatMetricPair = (variant: MetricFormatterVariant, currentValue: number, newValue: number) => {
  const change = newValue - currentValue;
  const percentChange = currentValue > 0 ? ((change / currentValue) * 100).toFixed(1) : '0.0';

  if (variant === 'utilization' || variant === 'popularity') {
    return {
      current: `${currentValue.toFixed(1)}%`,
      new: `${newValue.toFixed(1)}%`,
      change: {
        absolute: `${change >= 0 ? '+' : ''}${change.toFixed(1)}%`,
        percentage: `${percentChange}%`
      }
    };
  }

  const currentRounded = Math.round(currentValue);
  const newRounded = Math.round(newValue);
  const roundedChange = newRounded - currentRounded;

  return {
    current: currentRounded,
    new: newRounded,
    change: {
      absolute: `${roundedChange >= 0 ? '+' : ''}${roundedChange}`,
      percentage: `${percentChange}%`
    }
  };
};

export const countHighlightedKeywords = (sections: KeywordSection[] | undefined): number => {
  if (!sections || sections.length === 0) return 0;
  let count = 0;
  sections.forEach((section) => {
    if (Array.isArray(section.content)) {
      section.content.forEach((item) => {
        if ((item as any).groupId) count += 1;
      });
    }
  });
  return count;
};

export const formatDateForDisplay = (timestamp?: number, dateString?: string): string | undefined => {
  if (timestamp) {
    return new Date(timestamp).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
  if (dateString) {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
  return undefined;
};

export const buildKeywordsPayload = (
  base: { retailerId: number; retailerSku: string; weekId: number },
  content: { title?: string; description?: string; bullets?: string[]; skuContentGenerationId?: string | undefined }
): ProductKeywordsPayload => {
  return {
    retailerId: base.retailerId,
    retailerSku: base.retailerSku,
    weekId: base.weekId,
    title: content.title,
    description: content.description,
    bulletPoints: content.bullets || [],
    contentMetricType: ContentMetricType.KeywordOrganicTraffic,
    skuContentGenerationId: content.skuContentGenerationId
  };
};

export const formatKeywordSections = (sections: KeywordSection[] | undefined): KeywordSection[] => {
  if (!sections || !Array.isArray(sections)) return [];
  return sections.map((section) => ({
    name: section.name,
    content: Array.isArray(section.content)
      ? section.content.map((item: any) => ({ phrase: item.phrase, groupId: item.groupId || undefined }))
      : [],
    groups: Array.isArray(section.groups)
      ? section.groups.map((group: any) => ({
          groupId: group.groupId,
          weights: Array.isArray(group.weights)
            ? group.weights.map((weight: any) => ({
                keyword: weight.keyword,
                is_client_keyword: weight.is_client_keyword
              }))
            : []
        }))
      : []
  }));
};


